import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Remove } from '@mui/icons-material';
import { Box, Grid, IconButton } from '@mui/material';
import { colors } from '../../assets/utils/colors';
import CustomCard2 from '../../components/cards/CustomCard2';
import PromotionDetailsSidebar from '../../components/sidebars/PromotionDetailsSidebar';
import ProductWidget from '../../components/widgets/ProductWidget';
import PageLayout from '../layouts/PageLayout';
import { useDispatch, useSelector } from 'react-redux';
import { map, size } from 'lodash';
import DataFetchingFeedback from '../../components/feedbacks/DataFetchingFeedback';
import NoDataFeedback from '../../components/feedbacks/NoDataFeedback';

// RTK query imports and redux
import { useGetSinglePromotionQuery } from '../../api/promotions/promotionAPI';
import { setPromotion } from '../../features/promotionSlice';
import { useGetProductByPromotionQuery } from '../../api/products/productAPI';
import { setPromotedProducts } from '../../features/productSlice';

// !############### MAIN FUNC ####################
const PromotionDetails = () => {
    const dispatch = useDispatch();
    const { promotion_id } = useParams();
    const { isSuccess, data: promotion, refetch } = useGetSinglePromotionQuery(
        promotion_id,
    );
    const {
        data: products,
        isSuccess: success,
        isLoading: loading,
        isError: error,
    } = useGetProductByPromotionQuery(promotion_id);

    const promo = useSelector((state) => state.promotions.promotion);
    const promotedProducts = useSelector(
        (state) => state.products.promotedProducts,
    );

    useEffect(() => {
        if (isSuccess) {
            dispatch(setPromotion({ promotion: promotion.data }));
        }

        if (success) {
            dispatch(setPromotedProducts({ promotedProducts: products.data }));
        }

        if (error) {
            dispatch(setPromotedProducts({ promotedProducts: [] }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess, success, error]);

    return (
        <>
            <PageLayout
                sidebar={
                    <PromotionDetailsSidebar
                        promotion={promo}
                        refetch={refetch}
                    />
                }
                head="Promotions details"
            >
                <CustomCard2 title={`Promotion products`} heightClear={640}>
                    <Grid container spacing={3} padding={2}>
                        {loading ? (
                            <DataFetchingFeedback />
                        ) : size(promotedProducts) ? (
                            map(promotedProducts, ({ product_details }) => (
                                <Grid
                                    item
                                    sm={2}
                                    key={product_details?.product_id}
                                    sx={{ position: 'relative' }}
                                >
                                    <ProductWidget
                                        product_banner={
                                            product_details?.product_banner
                                        }
                                        discounted_price={
                                            product_details?.discounted_price
                                        }
                                        isOnSale={product_details?.isOnSale}
                                        product_id={product_details?.product_id}
                                        product_name={
                                            product_details?.product_name
                                        }
                                        product_price={
                                            product_details?.product_price
                                        }
                                    />
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 110,
                                            right: -15,
                                            borderRadius: 50,
                                            bgcolor: 'red',
                                            zIndex: 999,
                                        }}
                                    >
                                        <IconButton
                                            size="small"
                                            sx={{
                                                color: colors.bgColor1,
                                                m: 0,
                                            }}
                                        >
                                            <Remove />
                                        </IconButton>
                                    </Box>
                                </Grid>
                            ))
                        ) : (
                            <NoDataFeedback message="No product found" />
                        )}
                    </Grid>
                </CustomCard2>
            </PageLayout>
        </>
    );
};

export default PromotionDetails;
